var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotebookNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#52C7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13C23.8257 13 24.6255 13.1112 25.3851 13.3195C24.829 14.0682 24.5 14.9957 24.5 16C24.5 18.4853 26.5147 20.5 29 20.5C30.0043 20.5 30.9318 20.171 31.6805 19.6149C31.8888 20.3745 32 21.1743 32 22C32 26.9706 27.9706 31 23 31H16C13.7909 31 12 29.2091 12 27V22C12 17.0294 16.0294 13 21 13H23ZM17.25 20C17.25 19.5858 17.5858 19.25 18 19.25H22C22.4142 19.25 22.75 19.5858 22.75 20C22.75 20.4142 22.4142 20.75 22 20.75H18C17.5858 20.75 17.25 20.4142 17.25 20ZM17.25 24C17.25 23.5858 17.5858 23.25 18 23.25H26C26.4142 23.25 26.75 23.5858 26.75 24C26.75 24.4142 26.4142 24.75 26 24.75H18C17.5858 24.75 17.25 24.4142 17.25 24ZM29 19C30.6569 19 32 17.6569 32 16C32 14.3431 30.6569 13 29 13C27.3431 13 26 14.3431 26 16C26 17.6569 27.3431 19 29 19Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookNotificationIcon);
export default __webpack_public_path__ + "static/media/notebook-notification-icon.acbeaca1c1aa9c8310df1634a75ca8f0.svg";
export { ForwardRef as ReactComponent };